import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { handleEmergency } from '../helpers';
import { useStore } from '..';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const AlertEmergencyDialogSlide: React.FC = () => {
    const [openDialog, setOpen, setAll] = useStore((store) => store.emergencyOpen);

    return (
        <Dialog
            open={openDialog}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => setOpen({ emergencyOpen: false })}
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle>Emergency Booking</DialogTitle>
            <DialogContent dividers>
                <DialogContentText id="alert-dialog-slide-warning" sx={{ pb: 1 }}>
                    You are about to set this booking as an emergency - which means we should attend straightaway.
                </DialogContentText>
                <DialogContentText id="alert-dialog-slide-question" sx={{ pb: 1, fontWeight: "bold" }}>
                    Is this correct?
                </DialogContentText>
                <DialogContentText id="alert-dialog-slide-reminder">
                    If the customer requires us later today or at a different time, please cancel and amend the booking accordingly.
                </DialogContentText>
            </DialogContent >
            <DialogActions>
                <Button variant='outlined' onClick={() => setOpen({ emergencyOpen: false })}>Amend</Button>
                <Button variant='contained' color="error" onClick={() => { setAll({ ...handleEmergency(), emergencyOpen: false }) }}>Set as Emergency</Button>
            </DialogActions>
        </Dialog >
    );
}

export default React.memo(AlertEmergencyDialogSlide);